import { makeAutoObservable } from "mobx";

import type { TranslationKey } from "@mr-portfolio-infrastructure/translations/use-label";

export type NotificationSeverity = "success" | "info" | "warning" | "error";

export interface AppNotification {
  notificationId: number;
  severity: NotificationSeverity;
  messageKey: TranslationKey | null;
  messageText: string | null;
}

export class NotificationStore {
  public queue: AppNotification[] = [];

  private nextNotificationId = 1;

  public constructor() {
    makeAutoObservable(this);
  }

  public get current(): AppNotification | null {
    const currentNotification = this.queue[0] ?? null;

    return currentNotification;
  }

  public showSuccess(messageKey: TranslationKey): void {
    this.enqueue("success", messageKey, null);
  }

  public showInfo(messageKey: TranslationKey): void {
    this.enqueue("info", messageKey, null);
  }

  public showError(messageKey: TranslationKey, messageText: string | null = null): void {
    this.enqueue("error", messageKey, messageText);
  }

  public dismissCurrent(): void {
    this.queue.shift();
  }

  private enqueue(severity: NotificationSeverity, messageKey: TranslationKey | null, messageText: string | null): void {
    this.queue.push({ notificationId: this.nextNotificationId, severity, messageKey, messageText });
    this.nextNotificationId += 1;
  }
}
